//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogAuth from './components/DialogAuth'
export default {
  name: 'AccountManagement',
  data() {
    return {
      filterForm: {
        fullName: '', // 人员姓名
        loginName: '', // 登录账号
      },
      allFilters: {},
      accounts: [],
      accountLoad: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      filterFormMember: {
        key: '',
      },
      ruleForm: {
        id: '',
        mobile: '',
        ruleForm: '',
      },
      passwordRuleForm: {
        id: '',
        mobile: '',
        name: '',
        password: '',
        surePassword: '',
      },
      rules: {
        roleIdList: [
          { required: true, message: '请选择角色', trigger: 'blur' },
        ],
      },
      dialogPasswordVisible: false, // 修改密码
      dialogInfoVisible: false, // 修改信息
      dialogAuthVisible: false, // 查看权限
      dialogRemoveAccountVisible: false, // 删除账号
      showAccountDialog: false, // 修改账号
      authData: [],
      ownAuthData: [],
      defaultProps: {
        children: 'children',
        label: 'menuName',
      },
      curRole: '',
      curAccount: {
        roleIdList: [],
      },
      editData: {
        roleIdList: [],
      },
      roles: [],
      authLoading: false,
    }
  },
  components: { DialogAuth },
  mounted() {
    this.getAccountList()
  },
  methods: {
    close(type) {
      this[type] = false
    },
    async editAccount() {
      try {
        let { status } = await this.$http.account.updateRoleInfo({
          accountId: this.editData.id,
          roleIds: Array.from(new Set(this.editData.roleIdList)),
        })
        if (status == 1) {
          this.showAccountDialog = false
          this.$message({
            type: 'success',
            message: '修改角色成功',
            duration: 2000,
          })
          this.getAccountList()
        }
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @descripttion: 选择角色
     * @Author: juanjuanhui
     * @Date: 2022-02-17 17:00:14
     * @param {*} data 已选项
     */
    handleChangeRoleList(data) {
      this.authLoading = true
      this.authData = []
      if (data && data.length > 0) {
        let params = {
          roleIdList: data,
        }
        this.$http.common
          .selectOwnSMenuTree(params)
          .then((res) => {
            this.authData = res.data
            this.authLoading = false
          })
          .catch(() => {
            this.authLoading = false
          })
      }
    },
    getRoleList() {
      let params = {
        roleType: 2,
      }
      this.$http.account.getAllSRoleList(params).then((res) => {
        this.roles = res.data
      })
    },
    /**
     * @descripttion: 查询机具
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:07:16
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getAccountList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:08:07
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.pagination.currentPage = 1
      this.getAccountList()
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:06:58
     */
    getAllFilters() {
      this.allFilters = { ...this.filterForm }
    },
    /**
     * @descripttion: 获取账号列表
     * @Author: juanjuanhui
     * @Date: 2022-02-23 11:41:48
     */
    getAccountList() {
      this.getAllFilters()
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.accountLoad = true
      this.$http.account
        .getManageAccount(params)
        .then((res) => {
          let { recordTotal, content: accounts } = res.data
          this.pagination.recordTotal = recordTotal
          this.accounts = accounts
          this.accountLoad = false
        })
        .catch(() => {
          this.accountLoad = false
        })
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getAccountList()
    },
    /**
     * @descripttion: 添加账号
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     */
    handleAddAccount() {
      this.$router.push({ path: '/setting/account-management/add' })
    },
    /**
     * @descripttion: 修改密码
     * @Author: juanjuanhui
     * @Date: 2022-02-15 17:35:16
     * @param {*}item 当前数据项
     */
    handleEditPassword(item) {
      this.passwordRuleForm = JSON.parse(JSON.stringify(item))
      this.dialogPasswordVisible = true
    },
    /**
     * @descripttion: 保存修改的密码
     * @Author: juanjuanhui
     * @Date: 2022-02-15 19:40:56
     * @param {*} formName
     * @return {*}
     */
    handleSavegPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { id, password, surePassword } = this.passwordRuleForm
          let params = {
            id,
            passwordFirst: password,
            passwordSecond: surePassword,
          }
          this.$http.account.updateAccountPwd(params).then(() => {
            this.dialogPasswordVisible = false
          })
        } else {
          return false
        }
      })
    },
    /**
     * @descripttion: 修改信息
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:19:33
     * @param {*} item 当前数据项
     */
    handleEditInfo(item) {
      this.ruleForm = JSON.parse(JSON.stringify(item))
      this.dialogInfoVisible = true
    },
    /**
     * @descripttion: 保存修改的信息
     * @Author: juanjuanhui
     * @Date: 2022-01-19 01:19:40
     * @param {*}
     * @return {*}
     */
    handleSaveInfo() {
      let { id, fullName } = this.ruleForm
      let params = {
        id,
        fullName,
      }
      this.$http.account.updateAccountInfo(params).then(() => {
        this.dialogInfoVisible = false
        this.getAccountList()
      })
    },
    /**
     * @descripttion: 查看权限
     * @Author: juanjuanhui
     * @Date: 2022-03-02 17:46:59
     * @param {*} item
     */
    handleLookAuth(item) {
      item.roleIdList = item.roleIdList ? item.roleIdList : []
      this.curAccount = item
      this.dialogAuthVisible = true
      this.ownAuthData = []
      let { roleIdList } = item
      if (roleIdList && roleIdList.length > 0) {
        roleIdList.forEach((item, index) => {
          this.getSelectOwnMenuTree({ roleIdList: [item], index })
        })
      }
    },
    /**
     * @descripttion: 获取某角色的权限
     * @Author: juanjuanhui
     * @Date: 2022-02-22 19:54:22
     * @param {*}
     */
    async getSelectOwnMenuTree(params) {
      let { roleIdList, index } = params
      let arr = this.curAccount.roleNames.split(',')
      try {
        let { data } = await this.$http.common.selectOwnSMenuTree({
          roleIdList,
        })
        this.ownAuthData.push({
          roleName: arr[index],
          authData: data,
        })
      } catch (error) {
        console.log(error)
      }
    },

    /**
     * @descripttion: 删除账号
     * @Author: juanjuanhui
     * @Date: 2022-02-15 20:24:15
     * @param {*} item
     * @return {*}
     */
    async handleRemoveAccount(item) {
      this.curAccount = item
      this.dialogRemoveAccountVisible = true
    },
    /**
     * @descripttion: 确认删除账号
     * @Author: juanjuanhui
     * @Date: 2022-02-15 20:26:37
     * @param {*}
     */
    handleSaveRemoveAccount() {
      this.$http.account
        .delManageAccount({ id: this.curAccount.id })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              type: 'success',
              message: '删除账号成功',
              duration: 2000,
            })
            this.dialogRemoveAccountVisible = false
            this.getAccountList()
          }
        })
    },
    /**
     * @description: 展示修改账号窗口
     * @Author: yangsibo
     * @Date: 2022-06-01 09:00:19
     * @return {*}
     */
    showAccount() {
      this.editData = JSON.parse(JSON.stringify(this.curAccount))
      this.getRoleList()
      this.handleChangeRoleList(this.editData.roleIdList)
      this.dialogAuthVisible = false
      this.showAccountDialog = true
    },
  },
}
